import React, { useCallback, useMemo, useState } from 'react';

import { ContextMenuContext, Payload, Position } from './context';

type ContextMenuProviderProps = {
  children: React.ReactNode;
};

export const ContextMenuProvider: React.FC<ContextMenuProviderProps> = ({
  children,
}) => {
  const [position, setPosition] = useState<Position>();
  const [payload, setPayload] = useState<Payload>();

  const close = useCallback(() => {
    setPosition(undefined);
    setPayload(undefined);
  }, []);

  const open = useCallback((newPosition?: Position, newPayload?: Payload) => {
    setPosition(newPosition);
    setPayload(newPayload);
  }, []);

  const value = useMemo(
    () => ({
      position,
      payload,
      open,
      close,
    }),
    [close, open, payload, position],
  );

  return (
    <ContextMenuContext.Provider value={value}>
      {children}
    </ContextMenuContext.Provider>
  );
};
